export default __webpack_public_path__ + "static/media/npwp-invalid-example.6bb88460.png";